export const types = {
    authLogged: '[auth] user logged',
    authLogOut: '[auth] user log out',
    userDataUpdated: '[auth] user data updated',

    uiAuthStartLoginLoading: '[ui] start login loading',
    uiAuthFinishLoginLoading: '[ui] finish login loading',
    uiAuthStartRegisterLoading: '[ui] start register loading',
    uiAuthFinishRegisterLoading: '[ui] finish register loading',
    uiUserDataUpdateStartLoading: '[ui] update user data start loading',
    uiUserDataUpdateFinishLoading: '[ui] update user data finish loading',
    uiChangePasswordStartLoading: '[ui] change pass start loading',
    uiChangePasswordFinishtLoading: '[ui] change pass finish loading',

    uiOpenUpdateModal: '[ui] open update modal',
    uiCloseUpdateModal: '[ui] close update modal',

    uiOpenPicModal: '[ui] open pic modal',
    uiClosePicModal: '[ui] close pic modal',

    uiClearMessages: '[ui] clear messages',

    uiProfessionsStartLoading: '[ui] professions start loading',
    uiProfessionsFinishLoading: '[ui] professionsfinish loading',
    uiProfessionsLoaded: '[ui] professions loaded',

    uiSpecialtiesStartLoading: '[ui] specialties start loading',
    uiSpecialtiesFinishLoading: '[ui] specialties finish loading',
    uiSpecialtiesLoaded: '[ui] specialties loaded',
    
    uiSectionsLoaded: '[ui] sections loaded',
    uiSectionsStartLoading: '[ui] sections start loading',
    uiSectionsFinishLoading: '[ui] sections finish loading',

    uiPageStartLoading: '[ui] page start loading',
    uiPageFinishLoading: '[ui] page finish loading',

    uiLastSocialMediasStartLoading: '[ui] last social medias start loading',
    uiLastSocialMediasFinishLoading: '[ui] last social medias finish loading',

    uiLastMediasStartLoading: '[ui] last medias start loading',
    uiLastMediasFinishLoading: '[ui] last medias finish loading',

    uiMediaDataStartLoading: '[ui] media data start loading',
    uiMediaDataFinishLoading: '[ui] media data finish loading',

    uiMediasStartLoading: '[ui] medias start loading',
    uiMediasFinishLoading: '[ui] medias finish loading',

    uiMediasHistoryStartLoading: '[ui] medias history start loading',
    uiMediasHistoryFinishLoading: '[ui] medias history finish loading',

    uiRelatedMediasStartLoading: '[ui] related medias start loading',
    uiRelatedMediasFinishLoading: '[ui] related medias finish loading',

    uiMediasSavedStartLoading: '[ui] medias saved start loading',
    uiMediasSavedFinishLoading: '[ui] medias saved finish loading',

    lastmediasLoaded: '[medias] last medias loaded',
    lastSocialmediasLoaded: '[medias] last social medias loaded',
    mediasLoaded: '[medias] loaded',
    mediaDataLoaded: '[medias] media data loaded',
    mediasHistoryLoaded: '[medias] history loaded',
    relatedmediasLoaded: '[medias] related medias loaded',
    mediasSavedLoaded: '[medias] saved loaded',

    mediasSavedAddNew: '[medias] saved add new',
    mediasSavedDelete: '[medias] saved delete',
    mediaUpdated: '[medias] updated'
};